import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { BugPriority, BugSeverity, StatoAnomalia } from 'src/app/model/customer';
import { ProductDto } from 'src/app/model/ProductDto';
import { BugGravities, ProjectBugReleases } from 'src/app/model/ProjectBugReleases';
import { CmsService } from 'src/app/core/services/cms.service';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { ArchiviedDocumentInfo } from 'src/app/model/ArchiviedDocumentInfo';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { ProductDownloadService } from 'src/app/core/services/product-download.service';
import { ReportsService } from 'src/app/core/services/reports.service';
export interface GravityElement {
  gravityNumber: string;
  gravityDescription: string;
}

@Component({
  selector: 'ms-product-bug-details',
  templateUrl: './product-bug-details.component.html',
  styleUrls: ['./product-bug-details.component.scss']
})

export class ProductBugDetailsComponent implements OnInit {
  bug: ProjectBugReleases;
  productDto: ProductDto;
  displayedColumns: string[] = ['gravityNumber', 'gravityDescription'];
  archiviedDocuments: ArchiviedDocumentInfo[] = [];

  localizedFields: Map<string, string> = new Map<string, string>();
  dataSource: GravityElement[] ;
  public gravityTexts: BugGravities
  public gravityElements: GravityElement[] = [];
  bugsReportReleseNotesDisclaimer: string;
  bugsReportReleseNotesDisclaimerDetail: string;
  isLoading: boolean = false;

  constructor(
    private router: Router,
    private navigateService: NavigateService,
    private productDownloadService: ProductDownloadService,
    public cmsService: CmsService,
    public workFlow: WorkFlowService,
    public reportsService: ReportsService
  ) {}

  async ngOnInit(){
    /*await this.getCmsObj();
    this.TableGravity();*/
    this.localizedFields = this.reportsService.getLocalizedFields(this.workFlow.getLanguageForCms());
    if(!this.navigateService.getLocalStorageData<ProjectBugReleases>('bug') || !this.navigateService.getLocalStorageData<ProductDto>('productDto'))
      this.router.navigate(['/products-download/product-viewer/bugs']);

    if(this.navigateService.getLocalStorageData<ArchiviedDocumentInfo>('archiviedDocuments'))
      this.archiviedDocuments = this.navigateService.getLocalStorageData<ArchiviedDocumentInfo[]>('archiviedDocuments');

    this.dataSource = this.navigateService.getLocalStorageData<GravityElement[]>('bugGravityTables');
    this.gravityElements = this.dataSource;
    this.gravityTexts = this.navigateService.getLocalStorageData<BugGravities>('bugGravities');

    this.bugsReportReleseNotesDisclaimer = this.navigateService.getLocalStorageData<string>('bugsReportReleseNotesDisclaimer');
    this.bugsReportReleseNotesDisclaimerDetail = this.navigateService.getLocalStorageData<string>('bugsReportReleseNotesDisclaimerDetail');

    this.bug = this.navigateService.getLocalStorageData<ProjectBugReleases>('bug');
    this.productDto = this.navigateService.getLocalStorageData<ProductDto>('productDto');
  }


  getStatus(bug: ProjectBugReleases): string {
    return Object.keys(StatoAnomalia).find(key => StatoAnomalia[key] === bug.BugsStatus) ?? '';
  }

  getResolvedForProducts(bug: ProjectBugReleases): string[]{
    let result: string[] = []
    bug.Releases.forEach(br => {
      result.push(`${br.Description ?? ''} Rel. ${br.ReleaseNrExpected != '' ?  br.ReleaseNrExpected : 'N.D.'}`)
    })
    return result
  }

  getInquiriedByProducts(bug: ProjectBugReleases): string[]{
    let result: string[] = []
    bug.Inquiries.forEach(br => {
      result.push(`${br.Description ?? ''} Rel. ${br.ReleaseNr != '' ?  br.ReleaseNr : 'N.D.'} in data: ${new Date(br.RecordingDate).toLocaleDateString()}`)
    })
    return result
  }

  getBugSeverityNr(bug: ProjectBugReleases): string{
    switch (bug.Severity){
      case BugSeverity.Gravita1: return '1' +' - '+ this.gravityTexts.Gravity1
      case BugSeverity.Gravita2: return '2' +' - '+  this.gravityTexts.Gravity2
      case BugSeverity.Gravita3: return '3'+' - '+  this.gravityTexts.Gravity3
      case BugSeverity.Gravita4: return '4' +' - '+  this.gravityTexts.Gravity4
      case BugSeverity.Gravita5: return '5' +' - '+  this.gravityTexts.Gravity5
      default: return this.gravityTexts.GravityUndefined
    }
  }

  getBugPriority(bug: ProjectBugReleases): string {
    let result = ""
    Object.keys(BugPriority).filter((v) => isNaN(Number(v))).forEach(key => {
      if(BugPriority[key] == bug.Priority && BugPriority[key] != BugPriority.Nothing)
        result = key;
    })
    return this.toSentenceCase(result);
  }

  toSentenceCase(str: string): string{
    const s = str && str
      .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
      .join(' ');
    return s.slice(0, 1).toUpperCase() + s.slice(1);
  };

  public downloadArchiviedDocument(archiviedDocument: ArchiviedDocumentInfo) {
    this.productDownloadService.downloadArchiviedDocument(archiviedDocument).subscribe(
      data => {
        if(data['ok'] == false){
          alert("Error")
          return;
        }
        switch (data.type) {
          case HttpEventType.DownloadProgress:
            break;
          case HttpEventType.Response:
            this.downloadFile(data, archiviedDocument);
            break;
        }
      }
    );
  }

  downloadFile(data: HttpResponse<Blob>, archiviedDocument: ArchiviedDocumentInfo){
    this.isLoading = true;
    const downloadedFile = new Blob([data.body], { type: data.body.type });
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.download = archiviedDocument.Name;
    a.href = URL.createObjectURL(downloadedFile);
    a.target = '_blank';
    a.click();
    document.body.removeChild(a);
    this.isLoading = false;
  }
}
